// src/data/crisisSupport.js
// Crisis support numbers by country for every crisis listing in Story Threads
// Vibe (the Resources page, the home page and the dashboard's support card).
// The app serves seven markets: Australia, New Zealand, India, the UK,
// Ireland, Canada and the US.
//
// ⚠️ The numbers are not kept here. They live in the fleet's one table,
// packages/crisis-support/src/services.js, with the date each was verified
// and the page it was verified on. Change a number or its hours THERE, never
// by overriding it here. This app shows the 'young' list, as the other Vibe
// apps do.
//
// ⚠️ Never fall back to another country's list. `getCrisisSupport` returns
// null for an unknown region so the UI can say "we don't hold numbers for
// your region — call your local emergency number" rather than dial a number
// that reaches nobody.
//
// Imported by relative path, not a Vite alias: the Knowledge Hub importer
// loads this file in plain Node to index it (appRegistry.json, `safety`).

import {
  crisisSupportTable,
  countryPreference,
  normaliseCountryKey,
  detectCountry,
  emergencyCallAdvice,
  COUNTRY_KEYS,
  DEFAULT_COUNTRY
} from '../../../../packages/crisis-support/src/index.js';

export const CRISIS_SUPPORT = crisisSupportTable('young');

export { COUNTRY_KEYS, DEFAULT_COUNTRY, normaliseCountryKey, detectCountry, emergencyCallAdvice };

// Where the reader's choice lives, shared by every surface that shows numbers.
export const COUNTRY_PREF_KEY = 'story-threads-vibe_crisis_country';

export const { readCountryPref, writeCountryPref, initialCountry } = countryPreference(COUNTRY_PREF_KEY);

/**
 * Look up crisis support for a region. Fails CLOSED: an unknown or missing
 * region returns null so callers can say "we don't hold numbers for your
 * region" and render no tel: link. Never hand someone another country's line.
 */
export const getCrisisSupport = (key) => CRISIS_SUPPORT[normaliseCountryKey(key)] || null;

export default CRISIS_SUPPORT;
